import { bucketUrl } from "@/app/shared/utils/url";
import { ImportType } from "./enums";

const baseUrl = `${bucketUrl}/imports-templates`;

export const templates = {
  clients: [
    {
      type: ImportType.ContactsSequence,
      title: "Asignación de contactos a Secuencia",
      url: `${baseUrl}/asignacion_a_secuencia.zip`,
      description:
        "Esta plantilla te permite asignar contactos existentes de forma masiva a una secuencia activa o inactiva, Descarga nuestra plantilla XLSX para realizar el proceso.",
    },
    {
      type: ImportType.Phones,
      title: "Plantilla de teléfonos",
      url: `${baseUrl}/telefonos.zip`,
      description:
        "Agrega o actualiza teléfonos de tus contactos. Descarga aquí nuestra plantilla XLSX para realizar el proceso.",
    },
    {
      type: ImportType.Addresses,
      title: "Plantilla de direcciones",
      url: `${baseUrl}/direcciones.zip`,
      description:
        "Agrega o actualiza direcciones de tus contactos. Descarga nuestra plantilla XLSX para realizar el proceso.",
    },
    {
      type: ImportType.Emails,
      title: "Plantilla de correos",
      url: `${baseUrl}/emails.zip`,
      description:
        "Agrega o actualiza correos de tus contactos. Descarga nuestra plantilla XLSX para realizar el proceso.",
    },
    {
      type: ImportType.Contacts,
      title: "Plantilla de referidos",
      url: `${baseUrl}/referidos.zip`,
      description:
        "Agrega o actualiza referidos de tus contactos. Descarga nuestra plantilla XLSX para realizar el proceso.",
    },
    {
      type: ImportType.Payments,
      title: "Plantilla para pagos:",
      url: `${baseUrl}/pagos.zip`,
      description:
        "Importa pagos relacionados a tus productos. Descarga nuestra plantilla XLSX para realizar el proceso.",
    },
    {
      type: ImportType.ExternalTypifications,
      title: "Plantilla para tipificaciones externas:",
      url: `${baseUrl}/gestiones_externas.zip`,
      description:
        "Importa el historial o registro de las tipificaciones realizadas previamente a tus contactos. Descarga nuestra plantilla XLSX para realizar el proceso.",
    },
  ],
  others: [
    {
      type: [ImportType.ActiveClients, ImportType.InactiveClients],
      title: "Plantilla para activar / inactivar contactos",
      url: `${baseUrl}/activa_inactiva_contactos.zip`,
      description:
        "Re activa contactos que hayas dado de baja anteriormente o inactiva contactos activos en tu CRM. Descarga nuestra plantilla XLSX para realizar el proceso.",
    },
    {
      type: [ImportType.ActivateAccounts, ImportType.InactivateAccounts],
      title: "Plantilla para activar / inactivar productos:",
      url: `${baseUrl}/activa_inactiva_cuentas.zip`,
      description:
        "Re activa productos que hayas dado de baja anteriormente o inactiva productos activos en tu CRM.  Descarga nuestra plantilla XLSX para realizar el proceso.",
    },
    {
      type: [ImportType.ActivatePhones, ImportType.InactivatePhones],
      title: "Plantilla para activar / inactivar teléfonos:",
      url: `${baseUrl}/activa_inactiva_telefonos.zip`,
      description:
        "Re activa teléfonos que hayas dado de baja anteriormente o inactiva teléfonos activos en tu CRM.   Descarga nuestra plantilla XLSX para realizar el proceso.",
    },
    {
      type: ImportType.AgentsAssignment,
      title: "Plantilla de asignación de usuarios:",
      url: `${baseUrl}/asignacion_usuarios.zip`,
      description:
        "Asigna contactos específicos a tus usuarios. Según tu configuración en Campañas, estos tendrán prioridad sobre los contactos en sus gestiones. Descarga nuestra plantilla XLSX para realizar el proceso.",
    },
  ],
};
